import React from "react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";

const PolicyBody = ({ sections }) => (
  <div className="space-y-6">
    {sections.map((section, i) => (
      <div key={i} data-testid={`policy-section-${i}`}>
        <h4 className="text-base font-semibold text-brand-navy">
          {section.heading}
        </h4>
        {section.subheading && (
          <p className="mt-1 text-sm font-semibold text-slate-600">
            {section.subheading}
          </p>
        )}
        {section.paragraphs?.map((p, j) => (
          <p
            key={j}
            className="mt-2 text-sm leading-relaxed text-slate-500 whitespace-pre-line"
          >
            {p}
          </p>
        ))}
        {section.bullets && (
          <ul className="mt-3 space-y-2">
            {section.bullets.map((b, k) => (
              <li
                key={k}
                className="flex gap-2 text-sm leading-relaxed text-slate-500"
              >
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-teal" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    ))}
  </div>
);

export const LegalAccordion = ({ value, onValueChange }) => {
  const { t } = useTranslation();
  // Pull the full localized policy trees from i18next — arrays preserved
  // via returnObjects. Falls back to English if the FR bundle is missing
  // any section.
  const policies = [
    { id: "terms",    label: t("legalContent.terms.label"),    sections: t("legalContent.terms.sections",    { returnObjects: true }) },
    { id: "privacy",  label: t("legalContent.privacy.label"),  sections: t("legalContent.privacy.sections",  { returnObjects: true }) },
    { id: "security", label: t("legalContent.security.label"), sections: t("legalContent.security.sections", { returnObjects: true }) },
  ];
  return (
    <div className="bg-white" id="legal" data-testid="legal-accordion-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Accordion
          type="single"
          collapsible
          value={value}
          onValueChange={onValueChange}
          className="w-full"
        >
          {policies.map((policy) => (
            <AccordionItem
              key={policy.id}
              value={policy.id}
              className="border-slate-200"
            >
              <AccordionTrigger
                data-testid={`legal-trigger-${policy.id}`}
                className="text-base font-semibold text-brand-navy hover:no-underline py-5"
              >
                {policy.label}
              </AccordionTrigger>
              <AccordionContent className="pb-8">
                <PolicyBody sections={Array.isArray(policy.sections) ? policy.sections : []} />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default LegalAccordion;
